import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { CONFIRM } from "@/constants/testIds";

export const ConfirmDialog = ({ open, onOpenChange, title, description, onConfirm }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent data-testid={CONFIRM.dialog}>
      <AlertDialogHeader>
        <AlertDialogTitle className="font-heading tracking-tight">{title}</AlertDialogTitle>
        <AlertDialogDescription>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel className="rounded-full" data-testid={CONFIRM.cancel}>Batal</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} className="rounded-full bg-red-600 hover:bg-red-700 text-white" data-testid={CONFIRM.confirm}>Hapus</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
